import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=10a6e7fa&"
import script from "./ClientEdit.js?vue&type=script&lang=js&"
export * from "./ClientEdit.js?vue&type=script&lang=js&"
import style0 from "./ClientEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports